 
import * as React from "react";
import { SVGProps } from "react";
import LogoSVG from "./logos/logo.svg?react";
import LogoWhiteSVG from "./logos/logoWhite.svg?react";
import TMLogoWhiteSVG from "./logos/logoTrademarkedWhite.svg?react";
import TMLogoSVG from "./logos/logoTrademarked.svg?react";

function Logo(props: { white?: boolean; trademarked?: boolean } & SVGProps<SVGSVGElement>) {
    const { white, trademarked, ...svgProps } = props;

    if (trademarked) {
        if (white) {
            return <TMLogoWhiteSVG {...svgProps} />;
        }
        return <TMLogoSVG {...svgProps} />;
    }

    if (white) {
        return <LogoWhiteSVG {...svgProps} />;
    }

    return <LogoSVG {...svgProps} />;
}

export default Logo;
